import React from 'react';
import styles from './switch.module.css';

export const Switch = ({ isSelected, onChange, label }) => {
  const handleToggle = () => {
    onChange(!isSelected);
  };

  return (
    <div className={styles.container} onClick={handleToggle}>
      <div className={`${styles.track} ${isSelected ? styles.selected : ''}`}>
        <div className={`${styles.thumb} ${isSelected ? styles.selected : ''}`} />
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};
